















































import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import EditDocument from "./EditDocument.vue";
import ShowDocumentDetail from "./ShowDocument/ShowDocumentDetail.vue";
import ButtonChangeRead from "./ButtonChangeRead.vue";

export default Vue.extend({
  components: {
    ShowDocumentDetail,
    EditDocument,
    ButtonChangeRead
  },
  data() {
    return {
      page: 1,
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
          sortable: false,
        },
        { text: "Número", sortable: false, align: "start", value: "number" },
        {
          text: "Descripción",
          sortable: false,
          align: "start",
          value: "description",
        },
        {
          text: "Tipo de Documento",

          sortable: false,
          align: "start",
          value: "document_type.name",
        },
        {
          text: "Depto.",
          sortable: false,
          align: "start",
          value: "location.name",
        },
        { text: "Fecha", sortable: false, align: "start", value: "created_at" },
        {
          text: "Última Actualización",
          sortable: false,
          align: "start",
          value: "updated_at",
        },
        { text: "Acciones", sortable: false, align: "start", value: "action" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getDocuments: "documents/getMyDocument",
      getLoading: "documents/getLoading",
    }),
  },
  mounted() {
    // this.setDocument({id:this.getCurrentUserLoggedIn().id});
    this.changePage();
  },
  methods: {
    stateColor(state: string) {
      let classColor = "";
      switch (state) {
        case "recibido":
          classColor = "blue lighten-4";
          break;
        case "enviado":
          classColor = "yellow lighten-4";
          break;         
        default:
          classColor=""
          break;
      }
      return classColor;
    },
    changePage() {
      this.$store.commit("documents/setPageMyDocument", this.page);
      this.setDocument();
    },
    ...mapActions({
      setDocument: "documents/getMyDocument",
    }),
  },
});
